import SwiperController from "./components/previews/swiper";
import './components/pager';
import EventBus from "./events/EventBus";
var swiper = new SwiperController('.prod-teaser', window.devicePixelRatio);
document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () { return swiper.update(); });
});
EventBus.on('products:load', function () { return swiper.update(); });
EventBus.on('products:unload', function () { return swiper.destroy(); });
